module.exports = __webpack_public_path__ + "media/images/banner-white-mode-ed44d3094146e1d4bc83a37f0e77a619.png";